import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Dotdotdot from 'react-dotdotdot';
import classNames from 'classnames';
import ReadMore from 'components/ReadMore';
import { SegmentUiElements } from '@foxcorp/delta-web-analytics';
import { noop } from 'helpers/GlobalHelper';

const Subtitle = props => {
  const {
    account,
    link,
    isDisabled,
    isRedirect,
    name,
    onTileClick,
    onTileMouseDown,
    originalItem,
    percentWatched,
    recommendationIdData,
    subtitle,
    subtitleLines,
    subtitleText: subtitleTextProp,
    target,
    titleText,
    theme,
    truncateSubtitle,
  } = props;
  let subtitleLink = link;
  const subTitleClasses = [theme.subtitle];
  if (!subtitle || subtitle.length === 0) return null;
  let subtitleText;
  if (truncateSubtitle) {
    subtitleText = (
      <ReadMore moreText="More" lessText="Less" lines={subtitleLines || 2} theme={theme}>
        {subtitle}
      </ReadMore>
    );
  } else {
    subtitleText = subtitleLines ? (
      <Dotdotdot clamp={subtitleLines}>{subtitle}</Dotdotdot>
    ) : (
      subtitle
    );
  }
  if (!link || truncateSubtitle || isDisabled) {
    return <div className={classNames([theme.subtitle, theme.disabled])}>{subtitleText}</div>;
  }
  if (isRedirect) {
    subtitleLink = null;
    subTitleClasses.push(theme.redirectLink);
  }
  const onClick = () => {
    if (onTileClick) {
      onTileClick({
        originalItem,
        name,
        percentWatched,
        account,
        recommendationIdData,
        subtitleText: subtitleTextProp,
        titleText,
        uiElement: SegmentUiElements.SERIES_EPISODE,
      });
    }
  };

  const onMouseDown = e =>
    e.button === 1 ? onTileMouseDown({ uiElement: SegmentUiElements.SERIES_EPISODE }) : noop;

  return (
    <Link
      to={subtitleLink}
      target={target}
      className={classNames(subTitleClasses)}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      {subtitleText}
    </Link>
  );
};

Subtitle.defaultProps = {
  account: null,
  isDisabled: false,
  isRedirect: false,
  link: null,
  name: null,
  onTileClick: null,
  originalItem: {},
  percentWatched: null,
  recommendationIdData: null,
  subtitle: null,
  subtitleLines: null,
  subtitleText: null,
  target: null,
  theme: {},
  titleText: null,
  truncateSubtitle: null,
};

Subtitle.propTypes = {
  account: PropTypes.shape({}),
  isDisabled: PropTypes.bool,
  isRedirect: PropTypes.bool,
  link: PropTypes.string,
  name: PropTypes.string,
  onTileClick: PropTypes.func,
  onTileMouseDown: PropTypes.func,
  originalItem: PropTypes.shape({}),
  percentWatched: PropTypes.number,
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitleLines: PropTypes.number,
  subtitleText: PropTypes.string,
  target: PropTypes.string,
  titleText: PropTypes.string,
  truncateSubtitle: PropTypes.bool,
  theme: PropTypes.shape({}),
};

export default Subtitle;
